import { ChallengeStatus, ChallengeType } from "@/components/core/ChallengeItem/ChallengeItem"
import { ROUTES } from "@/conf"
import useMediaQuery from "@/hooks/useMediaQuery"
import { useRouter } from "next/navigation"
import { useState } from "react"
import { STATE_BONUS, STATE_VISITED, SUCCESS } from "tailwind.config"

interface Props {
  status: ChallengeStatus
  type: ChallengeType
  comicsSlug: string
}

const useChallengeItem = ({ status, type, comicsSlug }: Props) => {
  const [showLockedLocationRewardModal, setShowLockedLocationRewardModal] = useState(false)
  const [showBonusLockedModal, setShowBonusLockedModal] = useState(false)

  const { isMediaQuery: isDesktop } = useMediaQuery({ breakpoint: 1024 })

  const shine = status === ChallengeStatus.COMPLETED
  const locked = status === ChallengeStatus.LOCKED

  const { push } = useRouter()

  let mainColor: string
  let title: string
  let textColor: string

  switch (type) {
    case ChallengeType.GAME:
      mainColor = SUCCESS[300]
      title = "Odehrání komiksu"
      textColor = "text-success-300"
      break
    case ChallengeType.LOCATION:
      mainColor = STATE_VISITED[50]
      title = "Navštívení místa"
      textColor = "text-stateVisited-50"
      break
    case ChallengeType.BONUS:
      mainColor = STATE_BONUS[50]
      title = "Bonusová otázka"
      textColor = "text-stateBonus-50"
      break
  }

  const handleLocationClick = () => {
    if (locked) {
      setShowLockedLocationRewardModal(true)
    } else {
      push(`${ROUTES.cartoonDetail}/${comicsSlug}?section=game`)
    }
  }

  const handleBonusClick = () => {
    if (locked) {
      setShowBonusLockedModal(true)
    } else {
      push(`${ROUTES.cartoonDetail}/${comicsSlug}?section=bonus`)
    }
  }

  return {
    showLockedLocationRewardModal,
    showBonusLockedModal,
    shine,
    handleLocationClick,
    handleBonusClick,
    mainColor,
    textColor,
    title,
    locked,
    setShowLockedLocationRewardModal,
    setShowBonusLockedModal,
    isDesktop,
  }
}

export default useChallengeItem
